import { render, staticRenderFns } from "./ProviderLegalAtlasModal.vue?vue&type=template&id=81dc302c&scoped=true&"
import script from "./ProviderLegalAtlasModal.vue?vue&type=script&lang=js&"
export * from "./ProviderLegalAtlasModal.vue?vue&type=script&lang=js&"
import style0 from "./ProviderLegalAtlasModal.vue?vue&type=style&index=0&id=81dc302c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dc302c",
  null
  
)

export default component.exports